import { useCallback } from "react";

import { useMsal } from "@azure/msal-react";
import { useMutation, UseMutationResult } from "@tanstack/react-query";

import axios from "@/configs/axios";
import { KB_SOURCE } from "@/util/constants";
import { TeamsFile } from "@/util/interfaces/TeamsFile";
import { getUserInfo } from "@/utils/session";

interface UploadFileResult {
  data: any;
  status: number;
}

export const usePostImportFilesFromTeams = (
  loginRequestForBackend: any
): UseMutationResult<UploadFileResult, Error, TeamsFile[]> => {
  const { instance, accounts } = useMsal();
  const callUploadTeamsFiles = useCallback(
    async (files: TeamsFile[]): Promise<UploadFileResult> => {
      const { nameUser, userId } = getUserInfo();
      const response = await instance.acquireTokenSilent({
        ...loginRequestForBackend,
        account: accounts[0],
      });
      const url = `${process.env.REACT_APP_SERVER_HOST}/teams-sync/import-files`;
      if (files.length === 0) {
        return { status: 500, data: [] };
      } else {
        const processUploadBody = {
          source: KB_SOURCE,
          user_uuid: userId,
          uploaded_by: nameUser,
          batches: files.map((file) => ({
            team_name: file.channel?.teamName,
            channel_name: file.channel?.channelName,
            files: [
              {
                name: file.name,
                category: file.category ? file.category[0] : "",
                metadata: file.metadata,
                path: file.path,
                drive_id: file.channel.drive_id,
                item_id: file.id,
                uuid: file.uuid,
              },
            ],
          })),
        };
        const responseImport = await axios.post(url, processUploadBody, {
          headers: {
            oboToken: `${response.accessToken}`,
          },
        });
        return { status: 200, data: responseImport };
      }
    },
    []
  );

  return useMutation<UploadFileResult, Error, TeamsFile[]>({
    mutationFn: callUploadTeamsFiles,
  });
};
